import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../components/Loader';
import { usePasswordResetMutation } from '../slices/usersApiSlice';
import { toast } from 'react-toastify';
import { logout } from '../slices/authSlice';
import { resetCart } from '../slices/cartSlice';
import { useLocation } from 'react-router-dom';


const textStyle = {
  backgroundColor: '#f5f5dc',
};

const PasswordResetScreen = () => {
  const [email,           setEmail]           = useState('');
  const [password,        setPassword]        = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  //const [resetToken,      setResetToken]      = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location  = useLocation();


  const [passwordreset, { isLoading }] = usePasswordResetMutation();

  // Read token and email from sessionStorage (set by LoginScreen after OTP verified)
  useEffect(() => {
    const emailFromState = location.state?.email;
    if (!emailFromState) {
      // No navigation state — pset cookie may also be absent
      toast.error('Reset session not found. Please request a new code.');
      navigate('/login');
      return;
    }
    setEmail(emailFromState);
  }, [location.state, navigate]);

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!email)                        { toast.error('Email is missing'); return; }
    if (password !== confirmPassword)  { toast.error('Passwords do not match'); return; }
    if (password.length < 6)           { toast.error('Password must be at least 6 characters'); return; }

    try {
      // resetToken NOT sent — backend reads it from the pset httpOnly cookie
      await passwordreset({ email, password }).unwrap();

      dispatch(logout());
      dispatch(resetCart());
      toast.success('Password reset successfully. Please log in.');
      navigate('/login');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <Container fluid>
      <h1>Reset Password</h1>
      <Form onSubmit={submitHandler}>
        <Row>
          <Col md={4}>
            <div style={{
              border: '1px solid #ddd',
              padding: '10px',
              borderRadius: '10px',
              backgroundColor: '#F0F8FF',
            }}>
              <Form.Group className='my-2' controlId='email'>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type='email'
                  value={email}
                  readOnly
                  style={textStyle}
                />
              </Form.Group>
            </div>
          </Col>

          <Col md={4}>
            <div style={{
              border: '1px solid #ddd',
              padding: '10px',
              borderRadius: '10px',
              backgroundColor: '#F0F8FF',
            }}>
              <Form.Group className='my-2' controlId='password'>
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Enter new password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={textStyle}
                />
              </Form.Group>

              <Form.Group className='my-2' controlId='confirmPassword'>
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Confirm new password'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={textStyle}
                />
              </Form.Group>
            </div>
          </Col>
        </Row>

        <Button
          disabled={isLoading }
          type='submit'
          variant='primary'
          className='mt-3'
        >
          Reset Password
        </Button>

        {isLoading && <Loader />}
      </Form>
    </Container>
  );
};

export default PasswordResetScreen;
